import { apiClient } from './apiClient';
import { User } from '../types/auth';

export interface CreateUserRequest {
  email: string;
  username: string;
  password: string;
  full_name?: string;
  system_role: 'regular' | 'superadmin';
}

export interface UpdateUserRequest {
  full_name?: string;
  email?: string;
  system_role?: 'regular' | 'superadmin';
}

export const userService = {
  async getUsers(): Promise<User[]> {
    const { data } = await apiClient.get<User[]>('/admin/users/');
    return data;
  },

  async createUser(userData: CreateUserRequest): Promise<User> {
    const { data } = await apiClient.post<User>('/admin/users/', userData);
    return data;
  },

  async updateUser(id: string, userData: UpdateUserRequest): Promise<User> {
    const { data } = await apiClient.put<User>(`/admin/users/${id}`, userData);
    return data;
  },

  async resetPassword(id: string, newPassword: string): Promise<void> {
    await apiClient.put(`/admin/users/${id}/password`, { new_password: newPassword });
  },

  async toggleActive(id: string): Promise<User> {
    const { data } = await apiClient.put<User>(`/admin/users/${id}/toggle-active`, {});
    return data;
  },
};
